import { type Rut } from './types';

const DEFAULT_RUT_NUMERIC_PART = '0';
const DEFAULT_RUT_VERIFIER = '0';

const DEFAULT_RUT: Rut = `${DEFAULT_RUT_NUMERIC_PART}-${DEFAULT_RUT_VERIFIER}`;

export { DEFAULT_RUT, DEFAULT_RUT_NUMERIC_PART, DEFAULT_RUT_VERIFIER };
